import { Button, Dialog, DialogBody, DialogContent, DialogSurface, DialogTitle, Spinner, Title1, makeStyles, 
  shorthands, Subtitle2Stronger, Subtitle1, Body1, Title2, Caption1, Divider } from '@fluentui/react-components';
import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';

import {
  Box24Regular,
  Document16Regular,
  Calendar16Regular
  } from "@fluentui/react-icons";

import { useMsal, useAccount } from '@azure/msal-react';
import { silentRequest } from '../../authConfig';
import axios from 'axios';
import { useHistory, useLocation } from 'react-router-dom';

const useStyles = makeStyles({
  root: {
    width: "95%",
    maxWidth: "1165px",
    '@media (max-width: 1440px)': {
      ...shorthands.padding('0px', '5px'),
      maxWidth: "1080px",
    },
  },
  title: {
    ...shorthands.padding('0px', '20px'),
    '@media (max-width: 1440px)': {
      ...shorthands.padding('0px', '5px'),
    },
  },
  packageCard: {
    backgroundColor: '#fff',
    ...shorthands.padding('20px', '20px', '11px'),
    ...shorthands.border("0.8px", "solid", "rgb(237, 235, 233)"),
    // textAlign: 'center',
    // height: '158px', // Optional fixed height
    width: '358px', // Fixed width for the flex item
    borderRadius: "10px",
    transition: 'transform 0.3s ease, box-shadow 0.3s ease', // Smooth transition for scaling and shadow
    boxSizing: 'border-box',
    cursor: 'pointer', // Indicates interactivity
    '&:hover': {
      transform: 'scale(1.05)', // Expands the item on hover
      boxShadow: '0 4px 15px rgba(0, 0, 0, 0.2)', // Adds a shadow effect
    },
    '@media (max-width: 1440px)': {
      ...shorthands.padding('20px', '12px', '11px'),
      width: '342px', // Fixed width for the flex item
    },
  },
  container: {
    display: 'flex',
    flexWrap: 'wrap', // Enables wrapping of items
    gap: '24px', // Spacing between items
    ...shorthands.padding("0px", "20px"),
    // justifyContent: 'center', // Centers the items in the container
    '@media (max-width: 1440px)': {
      gap: '10px', // Spacing between items
    ...shorthands.padding("0px", "5px"),
    },
  },
  dialogContent: {
    display: "flex",
    flexDirection: "column",
    rowGap: "10px"
  },
  modalOverlay: {
    position: 'fixed',
    top: 0,
    left: 0,
    width: '100%',
    height: '100%',
    backgroundColor: 'rgba(0, 0, 0, 0.4)',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    zIndex: 1000,
  },
  modalContent: {
    // borderRadius: '8px',
    padding: '20px',
    // boxShadow: '0 4px 15px rgba(0, 0, 0, 0.2)',
    textAlign: 'center',
  }
});

function formatNumberWithCommas(number) {
  return number.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
}

const API_URL = process.env.REACT_APP_API_URL;
// const UAT_API_URL = 'https://ws.uat-lcpt.com'

const Packages = () => {
  const history = useHistory();
  const location = useLocation();

  const { t, i18n } = useTranslation();

    const styles = useStyles();

    const { instance, accounts } = useMsal();
    const account = useAccount(accounts[0] || {});

    const companyId = sessionStorage.getItem('companyId') || '';

    const [loadingDialog, setLoadingDialog] = useState({
      open: false
    })

    const [warningDialog, setWarningDialog] = useState({
      open: false,
      header: '',
      message: '',
    })

    const [changePackageDialog, setChangePackageDialog] = useState({
      open: false,
      package: null
    })

    const [manual, setManual] = useState(true)

    const [unpaidBill, setUnpaidBill] = useState([])
    const [getUnpaidSuccess, setGetUnpaidSuccess] = useState(true)

    const [loading, setLoading] = useState(true)
    const [getPackageSuccess, setGetPackageSuccess] = useState(false)
    const [getCompanyDetailSuccess, setGetCompanyDetailSuccess] = useState(false)
    const [billingType, setBillingType] = useState('')

    useEffect(() => {
      if (getPackageSuccess && getUnpaidSuccess && getCompanyDetailSuccess && billingType) {
        setLoading(false)
      }
      // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [getPackageSuccess, getUnpaidSuccess, getCompanyDetailSuccess, billingType])
    
    useEffect(() => {
      if (billingType) {
        getMainPackages()
      }

      // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [billingType])
    

    function getMainPackages() {
      const documentsListEndpoint = `${API_URL}/packages?packageType=main&type=document&etax=${billingType === 'etax' ? true : false}`
      // const documentsListEndpoint = `http://localhost:7071/api/packages?packageType=main&type=document&etax=${billingType === 'etax' ? true : false}`
    
      instance
      .acquireTokenSilent({ ...silentRequest, account: account })
      .then(async (tokenResponse) => {
        const currentPackageEndpoint = `${API_URL}/packages/current`

        const currentPackageResponse = await axios.get(currentPackageEndpoint, {
          headers: {
            Authorization: 'Bearer ' + tokenResponse.accessToken,
            'cid': companyId,
          },
        })

        console.log('currentPackageResponse', currentPackageResponse)

        const _currentPackage = currentPackageResponse.data

        setCurrentPackage(_currentPackage)

        const packagesResponse = await axios.get(documentsListEndpoint, {
                                    headers: {
                                      Authorization: 'Bearer ' + tokenResponse.accessToken,
                                      'cid': companyId,
                                    },
                                  })

        console.log("statementResponse", packagesResponse)

        const _unfilterPackages = packagesResponse.data.packages || []

        const _packages = _unfilterPackages.filter(_package => !_package.trial)

        _packages.sort(function (a, b) {
          return a.total - b.total
        });

        const _filterPackage = _currentPackage ? _packages.filter(_package => {
          if (_currentPackage.status === "active") return _package.packageId !== _currentPackage.packageId
          return true
        }) : _packages

        console.log('_filterPackage', _filterPackage)

        if (_currentPackage) {
          if (_currentPackage.status === "expired") {
            setMonthlyPackages(_packages.filter(_package => _package.monthsLimit === 1))
            setYearlyPackages(_packages.filter(_package => _package.monthsLimit === 12))
          } else {
            if (_currentPackage.monthsLimit > 1) {
              setMonthlyPackages([])
              setYearlyPackages(_filterPackage.filter(_package => _package.monthsLimit > 1 && _package.total > _currentPackage.total))
            } else {
              setMonthlyPackages(_filterPackage.filter(_package => _package.monthsLimit === 1 && _package.total > _currentPackage.total))
              setYearlyPackages(_filterPackage.filter(_package => _package.monthsLimit === 12))
            }
          }
        } else {
          setMonthlyPackages(_packages.filter(_package => _package.monthsLimit === 1))
          setYearlyPackages(_packages.filter(_package => _package.monthsLimit === 12))
        }


        setGetPackageSuccess(true)
        
      }).catch((error) => {
        //Acquire token silent failure, and send an interactive request
        console.log("getUnpaidStatements error", error);
        // instance.acquireTokenRedirect(silentRequest);
      });
    }
    
    async function fetchCompanyData() {
      instance
      .acquireTokenSilent({ ...silentRequest, account: account })
      .then((tokenResponse) => {
        axios
        // .get(API_URL + '/companies-details/' + response.data[0].id, {
        .get(API_URL + '/companies-details', {
            headers: {
                Authorization: 'Bearer ' + tokenResponse.accessToken,
                'cid': companyId
            },
        })
        .then((companiesDetailsResponse) => {
          if (companiesDetailsResponse.data) {
            if (companiesDetailsResponse.data.billings === undefined || companiesDetailsResponse.data.billings.manual === undefined || companiesDetailsResponse.data.billings.manual) {
              setManual(true)
              setLoading(false)

              // history.push({
              //   pathname: '/etax/documents/all',
              //   state: {},
              // });
            } else {
              setManual(false)
            }
     
          }

          setGetCompanyDetailSuccess(true)

        })
        .catch((error) => {
            console.log(error);
        })
      })
      .catch((error) => {
        //Acquire token silent failure, and send an interactive request
        console.log("fetchCompanyData error", error);
        // instance.acquireTokenRedirect(silentRequest);
      });
    }

    async function initLocationProps(_location) {
      const locationProps = _location.state
      console.log("locationProps", locationProps)
      if (locationProps && Object.keys(locationProps).length) {
        const _billingType = locationProps.billingType

        setBillingType(_billingType)
      } else {
        instance
        .acquireTokenSilent({ ...silentRequest, account: account })
        .then(async (tokenResponse) => {
          const currentPackageEndpoint = `${API_URL}/packages/current`

          const currentPackageResponse = await axios.get(currentPackageEndpoint, {
            headers: {
              Authorization: 'Bearer ' + tokenResponse.accessToken,
              'cid': companyId,
            },
          })

          console.log('currentPackageResponse', currentPackageResponse)

          const _currentPackage = currentPackageResponse.data

          setBillingType(_currentPackage.etax ? 'etax' : 'paper')
        })
        .catch((error) => {
          //Acquire token silent failure, and send an interactive request
          console.log("fetchCompanyData error", error);
          // instance.acquireTokenRedirect(silentRequest);
        })
      }
      
    }

    useEffect(() => {
      fetchCompanyData()

      initLocationProps(location)
      // getPackageAndAccountDetail()
      getUnpaidStatements()
      // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [])

    const [currentPackage, setCurrentPackage] = useState(null)

    useEffect(() => {
      console.log("currentPackage", currentPackage)
    }, [currentPackage])
    
    const [monthlyPackages, setMonthlyPackages] = useState([])
    const [yearlyPackages, setYearlyPackages] = useState([])

    function getUnpaidStatements() {
      const documentsListEndpoint = `${API_URL}/documents/billings?status=open`
    
      instance
      .acquireTokenSilent({ ...silentRequest, account: account })
      .then(async (tokenResponse) => {
        const statementResponse = await axios.get(documentsListEndpoint, {
                                    headers: {
                                      Authorization: 'Bearer ' + tokenResponse.accessToken,
                                      'cid': companyId,
                                    },
                                  })

        console.log("statementResponse", statementResponse)

        const documents = statementResponse.data.data?.documents || []

        if (documents.length) {
          const unpaidDocuments = documents.filter(_doc => {
            if (_doc.data.billing?.disabledCancel) {
              return true
            }
  
            const isoTimeNow = new Date().toISOString()
            if (isoTimeNow > _doc.data.dueDate) {
              return false
            }
  
            return true
          })

          setUnpaidBill(unpaidDocuments)
        }

        setGetUnpaidSuccess(true)

        
      }).catch((error) => {
        //Acquire token silent failure, and send an interactive request
        console.log("getUnpaidStatements error", error);
        // instance.acquireTokenRedirect(silentRequest);
      });
    }

    function handleOpenWarningDialog() {
      setWarningDialog(prev => ({...prev, open: true}))
    }

    function handleOpenChangePackageDialog(_package) {
      setChangePackageDialog(prev => ({...prev, open: true, package: _package}))
    }

    function handleChangePackage(_package) {
      handleCloseChangePackageDialog()
      
      setLoading(true)

      instance
      .acquireTokenSilent({ ...silentRequest, account: account })
      .then(async (tokenResponse) => {
        const createBillingEndpoint = `${API_URL}/documents/billings`

        const updatePackageResponse = await axios.post(createBillingEndpoint, { packageId: _package.packageId }, {
                                    headers: {
                                      Authorization: 'Bearer ' + tokenResponse.accessToken,
                                      'cid': companyId,
                                    }
                                  })

        console.log("updatePackageResponse", updatePackageResponse)

        history.push({
          pathname: '/billings/packages',
          state: {
            status: 'CHANGE_PACKAGE',
          },
        });
        
      }).catch((error) => {
        //Acquire token silent failure, and send an interactive request
        console.log("handleBuyAddOnPackage error", error);
        // instance.acquireTokenRedirect(silentRequest);
      });
    }

    function handleBuyPackage(_package) {
      if (unpaidBill.length) return handleOpenWarningDialog()

      if (currentPackage.trial) {
        history.push({
          pathname: '/payments/channels',
          state: {
            packageId: _package.packageId,
            total: _package.price,
            backUrl: '/packages',
          },
        });
      } else {
        if (currentPackage?.monthRemaining > 0 && _package.monthsLimit > 1 && currentPackage.total < _package.total) {
          history.push({
            pathname: '/packages/detail',
            state: {
              package: _package,
              backUrl: '/packages',
            },
          });
        } else if (currentPackage.status === "expired") {
          history.push({
            pathname: '/payments/channels',
            state: {
              packageId: _package.packageId,
              total: _package.price,
              backUrl: '/packages',
            },
          });
        } else if (_package.monthsLimit === 1 && currentPackage) {
          handleOpenChangePackageDialog(_package)
        } else {
          history.push({
            pathname: '/payments/channels',
            state: {
              packageId: _package.packageId,
              total: _package.price,
              backUrl: '/packages',
            },
          });
        }
      }
    }

    function handleCloseWarningDialog() {
      setWarningDialog(prev => ({...prev, open: false}))
    }

    function handleCloseChangePackageDialog() {
      setChangePackageDialog(prev => ({...prev, open: false, package: null}))
    }

    function handleCloseLoadingDialog() {
      setLoadingDialog(prev => ({...prev, open: false}))
    }

    function getCurrentPackageName(_package, language) {
      if (_package) {
        // const _packageName = getPackageName(_package.packageId, language)
        const _packageName = (language === 'th' ? _package.descriptionTH : _package.descriptionEN)

        if (_packageName) {
          return _packageName
        } else {
          return _package.name
        }
      } else {
        return "-"
      }
    }

    // (ไม่รวม VAT) : (Excl. VAT)
    // บาท : THB
    // ซื้อเลย  : Buy now
    return <div className={styles.root}>
      {manual ? (
        <div style={{ display: "flex", justifyContent: "center", marginTop: 21}}>
          {loading ? (
            <div style={{ display: "flex", alignContent: "center", height: "100%", width: "100%", justifyContent: "center"}}>
              <Spinner labelPosition="below" label={t(`packages.loading`)} />
            </div>
          ) : (
            <div style={{ display: "flex", flexDirection: "column"}}>
              <div style={{ marginBottom: 21}}>
                <Subtitle1>{t("packages.thisPageCannotReach")}</Subtitle1>
  
              </div>
              <div style={{ display: "flex", justifyContent: "center"}}>
                <Button 
                  appearance='primary' 
                  onClick={() =>  
                    history.push({
                      pathname: '/etax/documents/all',
                      state: {},
                    })}
                >
                  {t("packages.homepage")}
                </Button>
                
              </div>
            </div>
          )}
        </div>
      ) : (
        <>
          <div style={{
            display: "flex",
            flexDirection: "column",
          }}>
            <Title1 as='h1' className={styles.title}>
              <div style={{ display: "flex", flexDirection: "row"}}>
                <div className={styles.verticalCenter} style={{ paddingRight: 5}}>
                  <Box24Regular />
                </div>
                <div className={styles.verticalCenter}>
                  <div>{t("packages.mainPackage")}</div>
                </div>
              </div>
            </Title1>
            <Divider style={{ paddingLeft: 20, paddingRight: 20}} />
            {loading ? (
              <div style={{ marginTop: 16.6, display: "flex", alignContent: "center", height: "100%", width: "100%", justifyContent: "center"}}>
                <Spinner labelPosition="below" label={t(`packages.loading`)} />
              </div>
            ) : (
              <>
                {monthlyPackages.length ? (
                  <h2 style={{ paddingLeft: 20, paddingRight: 20}}>{t("packages.monthly")}</h2>
                ) : null}
                <div className={styles.container}>
                  {monthlyPackages.map(_package => (
                    <div className={styles.packageCard} key={_package.id}>
                      <div style={{ display: "flex", flexDirection: "column"}}>
                        <Subtitle2Stronger style={{ marginBottom: 6, paddingTop: 5 }}>{getCurrentPackageName(_package, i18n.language)}</Subtitle2Stronger>
                        <div style={{ padding: "4px 0px"}}>
                          <Document16Regular style={{ padding: "0px 2px 0px 0px"}} />
                          <Subtitle1>{formatNumberWithCommas(_package.total)} <Body1>{t("packages.documents")}</Body1></Subtitle1>
                        </div>
                        <div style={{ padding: "4px 0px"}}>
                          <Calendar16Regular style={{ padding: "0px 2px 0px 0px"}} />
                          <Subtitle1>{_package.monthsLimit} <Body1>{t("packages.month")}</Body1></Subtitle1>
                        </div>
                        <div style={{ display: "flex", flexDirection: "row", justifyContent: "space-between" }}>
                          <div style={{ marginTop: 4 }}>
                            <Title2 style={{ color: "#0f6cbd"}}>{formatNumberWithCommas(_package.price)}</Title2> 
                            <Subtitle2Stronger style={{ color: "#0f6cbd"}}> {t("packages.baht")}</Subtitle2Stronger> 
                            <Caption1> {t("packages.excludeVat")}</Caption1>
                          </div>
                          <div style={{ marginTop: 4 }}>
                            <Button appearance="primary" onClick={() => handleBuyPackage(_package)}>{t("packages.buyNow")}</Button>

                          </div>
                        </div>
                      </div>
                    </div>

                  ))}
                </div>
                {monthlyPackages.length ? (
                  <Divider style={{ paddingLeft: 20, paddingRight: 20, marginTop: 30 }} />
                ) : null}
                {yearlyPackages.length ? (
                  <h2 style={{ paddingLeft: 20, paddingRight: 20}}>{t("packages.yearly")}</h2>
                ) : null}
                <div className={styles.container}>
                  {yearlyPackages.map(_package => (
                    <div className={styles.packageCard} key={_package.id}>
                      <div style={{ display: "flex", flexDirection: "column"}}>
                        <Subtitle2Stronger style={{ marginBottom: 6, paddingTop: 5 }}>{getCurrentPackageName(_package, i18n.language)}</Subtitle2Stronger>
                        <div style={{ padding: "4px 0px"}}>
                          <Document16Regular style={{ padding: "0px 2px 0px 0px"}} />
                          <Subtitle1>{formatNumberWithCommas(_package.total)} <Body1>{t("packages.documents")}</Body1></Subtitle1>
                        </div>
                        <div style={{ padding: "4px 0px"}}>
                          <Calendar16Regular style={{ padding: "0px 2px 0px 0px"}} />
                          <Subtitle1>{_package.monthsLimit} <Body1>{t("packages.month")}</Body1></Subtitle1>
                        </div>
                        <div style={{ display: "flex", flexDirection: "row", justifyContent: "space-between" }}>
                          <div style={{ marginTop: 4 }}>
                            <Title2 style={{ color: "#0f6cbd"}}>{formatNumberWithCommas(_package.price)}</Title2> 
                            <Subtitle2Stronger style={{ color: "#0f6cbd"}}> {t("packages.baht")}</Subtitle2Stronger> 
                            <Caption1> {t("packages.excludeVat")}</Caption1>
                          </div>
                          <div style={{ marginTop: 4 }}>
                            <Button appearance="primary" onClick={() => handleBuyPackage(_package)}>{t("packages.buyNow")}</Button>

                          </div>
                        </div>
                      </div>
                    </div>

                  ))}
                </div>
              </>
            )}
          </div>
          {loadingDialog.open && (
            <div className={styles.modalOverlay} onClick={handleCloseLoadingDialog}>
              <div className={styles.modalContent}>
                <Spinner size="medium" />
              </div>
            </div>
          )}
          <Dialog open={warningDialog.open} onOpenChange={handleCloseWarningDialog}>
            <DialogSurface style={{ width: 350 }}>
              <DialogBody>
                <DialogTitle style={{ textAlign: "center" }}>{t("packages.payUnpaidFirst")}</DialogTitle>
                <DialogContent className={styles.dialogContent} style={{ textAlign: "center" }}>
                  <div style={{ display: "flex", justifyContent: "center", width: "100%", gap: 10}}>
                    <Button type="submit" appearance="primary" onClick={handleCloseWarningDialog}>
                      {t("packages.back")}
                    </Button>
                  </div>
                </DialogContent>
              </DialogBody>
            </DialogSurface>
          </Dialog>
          <Dialog open={changePackageDialog.open} onOpenChange={handleCloseChangePackageDialog}>
            <DialogSurface style={{ width: 350 }}>
              <DialogBody>
                <DialogTitle style={{ textAlign: "center" }}>{t(`packages.confirmPurchase`)}</DialogTitle>
                <DialogContent className={styles.dialogContent} style={{ textAlign: "center" }}>
                  {t(`packages.confirmPurchaseMessage`)}
                  <div style={{ display: "flex", justifyContent: "center", width: "100%", gap: 10}}>
                    <Button type="submit" appearance="primary" onClick={() => handleChangePackage(changePackageDialog.package)}>
                      {t(`packages.confirm`)}
                    </Button>
                    <Button appearance="secondary" onClick={handleCloseChangePackageDialog}>
                      {t(`packages.cancel`)}
                    </Button>
                  </div>
                </DialogContent>
              </DialogBody>
            </DialogSurface>
          </Dialog>
        </>
      )}
    </div>
};

export default Packages;
